import {
  Actions,
  AmountCell,
  Badge,
  CountCell,
  Image,
  ProgressCell,
  ToggleActiveStatus,
  ToggleArchiveStatus,
  useCanShow,
} from "@";

// Local cells — project-specific behavior we don't want to push into the
// shared cells folder.

const ImageCell = ({ src, alt }) => (
  <span className="inline-flex h-12 w-16 items-center justify-center overflow-hidden rounded-xl bg-gray-50 ring-1 ring-gray-100 dark:bg-gray-800 dark:ring-gray-700">
    <Image height={48} width={64} src={src} alt={alt} />
  </span>
);

const TitleCell = ({ title }) => {
  const truncated = title?.length > 35 ? title.slice(0, 35) + "…" : title;
  return (
    <span
      title={title}
      className="font-semibold tracking-tight text-gray-900 dark:text-gray-100"
    >
      {truncated || "—"}
    </span>
  );
};

const StatusCell = ({ isActive, isArchived }) => (
  <div className="flex flex-wrap gap-1.5 py-1">
    <Badge
      title={isActive ? "مفعل" : "غير مفعل"}
      color={isActive ? "green" : "red"}
    />
    {isArchived && <Badge title="مؤرشف" color="dark" />}
  </div>
);

export const TableActions = ({
  row,
  deleteHandler,
  ToggleActive,
  ToggleArchive,
}) => {
  return (
    <Actions
      notEdit={!useCanShow("editGiftProject")}
      notDelete={!useCanShow("editGiftProject")}
      row={row}
      url="giftProjects"
      delete={deleteHandler}
    >
      {useCanShow("editGiftProject") && (
        <>
          <ToggleActiveStatus row={row} click={ToggleActive} />
          <ToggleArchiveStatus row={row} click={ToggleArchive} />
        </>
      )}
    </Actions>
  );
};

// TanStack column defs
export const tableColumns = [
  {
    id: "image",
    header: "",
    size: 80,
    cell: ({ row }) => (
      <ImageCell src={row.original.imageFullUrl} alt={row.original.name} />
    ),
  },
  {
    id: "name",
    header: "الاسم",
    size: 220,
    cell: ({ row }) => <TitleCell title={row.original.name} />,
  },
  {
    id: "requiredAmount",
    header: "المبلغ المطلوب",
    cell: ({ row }) => <AmountCell value={row.original.requiredAmount} />,
  },
  {
    id: "totalAmount",
    header: "الإجمالي المُحصَّل",
    cell: ({ row }) => (
      <AmountCell value={row.original.totalAmount} tone="emerald" />
    ),
  },
  {
    id: "donationCount",
    header: "عدد التبرعات",
    size: 110,
    cell: ({ row }) => (
      <CountCell value={row.original.donationCount} label="متبرع" />
    ),
  },
  {
    id: "progressPercentage",
    header: "نسبة الإنجاز",
    size: 150,
    cell: ({ row }) => (
      <ProgressCell value={row.original.progressPercentage} tone="emerald" />
    ),
  },
  {
    id: "status",
    header: "الحالة",
    cell: ({ row }) => (
      <StatusCell
        isActive={row.original.isActive}
        isArchived={row.original.isArchived}
      />
    ),
  },
];
